import React from "react";
//#region types
import { FormFieldProps, RadioSelectionExtraProps } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import RadioSelectionGroup from "../baseFields/radioSelectionGroup";
//#endregion

function RadioSelectionFormField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const { name, field, value, handleOnChangeCustom, handleOnBlurCustom } = props;

  const extraProps = field.extraProps as RadioSelectionExtraProps<T>;

  const onChangeHandler = (e: React.ChangeEvent<any>, value: string) => {
    // eslint-disable-next-line eqeqeq --- disabling to avoid regression testing if changed
    const selectedItem = extraProps.items?.find((x) => x.id == value);

    handleOnChangeCustom(
      name,
      selectedItem?.id as number,
      true,
      extraProps.referenceFieldName as string | undefined,
      (selectedItem?.value as string) ?? undefined
    );
    handleOnBlurCustom(name);
  };

  return (
    <RadioSelectionGroup
      name={name}
      items={extraProps.items}
      value={value}
      onChange={onChangeHandler}
      row
      readOnly={props.readonly}
    />
  );
}

export default RadioSelectionFormField;
